module.exports = __webpack_public_path__ + "img/41.8c2dae47.jpg";